import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { Link } from 'foundations-components/transitional/components/Link';
import { getSalesPhoneNumber } from '../../../utils/talkToSales';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PHONE_NUMBERS_URL = 'https://www.hubspot.com/company/contact';
export const GetACallSuccessModal = ({
  onClose
}) => {
  const {
    phoneNumber: salesPhoneNumber,
    countryCode
  } = getSalesPhoneNumber();
  return /*#__PURE__*/_jsxs(Modal, {
    use: "conversational",
    width: 650,
    children: [/*#__PURE__*/_jsx(DialogHeader, {
      padding: "0",
      children: /*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: () => onClose()
      })
    }), /*#__PURE__*/_jsxs(DialogBody, {
      children: [/*#__PURE__*/_jsx(Text, {
        as: "p",
        marginBlockEnd: "400",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "purchaseMotions.talkToSales.communicationMethods.callSuccess"
        })
      }), /*#__PURE__*/_jsx(Text, {
        as: "h6",
        textTransform: "uppercase",
        marginBlockEnd: "400",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "purchaseMotions.talkToSales.communicationMethods.localization.or"
        })
      }), /*#__PURE__*/_jsx(Text, {
        as: "span",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "purchaseMotions.talkToSales.communicationMethods.localization.callNow"
        })
      }), /*#__PURE__*/_jsx(Text, {
        as: "h4",
        marginBlockEnd: "0",
        children: salesPhoneNumber
      }), countryCode && /*#__PURE__*/_jsx(Text, {
        as: "small",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `SharedI18nStrings.countryCodes.${countryCode}`
        })
      }), /*#__PURE__*/_jsx(View, {
        as: "div",
        marginBlockStart: "800",
        children: /*#__PURE__*/_jsx(Link, {
          href: PHONE_NUMBERS_URL,
          external: true,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "purchaseMotions.talkToSales.communicationMethods.localization.viewAllButton"
          })
        })
      })]
    })]
  });
};